import invitationService from '../services/invitationService';
import { toast } from 'sonner';

export const copyInviteLink = async (leagueId, t) => {
    try {
        const inviteLinkData = await invitationService.getInviteByLeagueId(leagueId);
        await navigator.clipboard.writeText(inviteLinkData);
        toast.success(t('leagueDetails.inviteLinkCopied'));
    } catch (error) {
        toast.error(t('leagueDetails.inviteLinkFailed'));
        console.error(error);
    }
};